import { formatLocalDateTime } from '../../utils/localDateTime';
import React, { useEffect, useState } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';
import type { FeedbackRecord } from '../../common/feedback';
import { managementCommunicationStyles as styles } from './communicationStyles';

const FeedbackPanel: React.FC<{ organizationId?: string }> = ({ organizationId }) => {
    const [feedback, setFeedback] = useState<FeedbackRecord[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [refresh, setRefresh] = useState(0);

    useEffect(() => {
        let active = true;
        setLoading(true);
        setFeedback([]);
        setError('');
        const callable = httpsCallable<{ action: 'list'; data: { organizationId?: string } }, { feedback: FeedbackRecord[] }>(getFunctions(undefined, 'us-central1'), 'manageFeedback');
        void callable({ action: 'list', data: organizationId ? { organizationId } : {} }).then(response => {
            if (active)
                setFeedback(response.data.feedback);
        }).catch(loadError => {
            if (active)
                setError(loadError.message || 'Feedback could not be loaded.');
        }).finally(() => {
            if (active)
                setLoading(false);
        });
        return () => { active = false; };
    }, [organizationId, refresh]);

    return <section aria-label="Feedback" className="space-y-4 animate-fade-in">
        <div className="flex flex-wrap items-center justify-between gap-3"><div><h2 className={styles.heading}>Feedback</h2><p className={`mt-1 ${styles.muted}`}>Client feedback, newest submissions first.</p></div><button type="button" disabled={loading} onClick={() => setRefresh(value => value + 1)} className={styles.secondaryButton}>Refresh</button></div>
        {error && <p role="alert" className={styles.error}>{error}</p>}
        {loading ? <p role="status" className="py-20 text-center text-sm text-slate-400">Loading feedback…</p> : <div className={styles.table}>
            <table className="w-full text-left text-sm"><thead className={styles.tableHead}><tr><th className="px-5 py-3">Feedback</th><th className="px-5 py-3">Organization</th><th className="px-5 py-3">Submitted By</th><th className="px-5 py-3" aria-sort="descending">Submitted</th></tr></thead>
                <tbody className="divide-y divide-slate-100">{feedback.map(item => <tr key={item.id} className={styles.tableRow}><td className="min-w-64 max-w-xl whitespace-pre-wrap [overflow-wrap:anywhere] px-5 py-4 text-slate-700">{item.text}</td><td className="px-5 py-4 text-slate-700">{item.organizationName}</td><td className="px-5 py-4"><p className="font-bold text-slate-800">{item.userName}</p><p className={styles.muted}>{item.userEmail}</p></td><td className={`whitespace-nowrap px-5 py-4 ${styles.muted}`}>{formatLocalDateTime(item.createdAt)}</td></tr>)}</tbody>
            </table>
            {!feedback.length && !error && <p className="p-12 text-center text-sm italic text-slate-400">No feedback submitted yet.</p>}
        </div>}
    </section>;
};

export default FeedbackPanel;
